module.exports = __webpack_public_path__ + "assets/logo-twolines-left-blue.5d32c81c.svg";